/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientOfferOut
 */
export interface ClientOfferOut {
    /**
     * 
     * @type {number}
     * @memberof ClientOfferOut
     */
    clientId: number;
    /**
     * 
     * @type {Date}
     * @memberof ClientOfferOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof ClientOfferOut
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof ClientOfferOut
     */
    archiveDate: Date;
}

export function ClientOfferOutFromJSON(json: any): ClientOfferOut {
    return ClientOfferOutFromJSONTyped(json, false);
}

export function ClientOfferOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOfferOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'modificationDate': (new Date(json['modificationDate'])),
        'offerId': json['offerId'],
        'archiveDate': (new Date(json['archiveDate'])),
    };
}

export function ClientOfferOutToJSON(value?: ClientOfferOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientId': value.clientId,
        'modificationDate': (value.modificationDate.toISOString()),
        'offerId': value.offerId,
        'archiveDate': (value.archiveDate.toISOString()),
    };
}


